import { transactionApi } from '~constants/constants';

export interface ITransactionApiConfig {
    baseUrl: string;
}

export class TransactionApi {
    private readonly url: string;

    constructor() {
        this.url = transactionApi;
    }

    public async loadTransaction() {
        const reqUrl = this.url + this.getDBGMethod('trans.get');

        return this.fetchJson(reqUrl, this.getReqBody('trans.get'));
    }

    private fetchJson = async (url: string, reqBody: string) => {
        try {
            const res = await fetch(url, {
                method: 'POST',
                body: `JSONRPC=${encodeURIComponent(reqBody)}`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            const json = await res.json();

            return json;
        } catch (err) {
            throw err;
        }
    };

    private getReqBody(name: string) {
        return JSON.stringify([
            {
                method: this.getDBGMethod(name),
                params: [
                    {
                        order_fields: ['SHIP_METHOD', 'items']
                    }
                ]
            }
        ]);
    }

    private getDBGMethod(methodName: string) {
        switch (methodName) {
            case 'trans.get':
                return 'trans.get';
            default:
                return '';
        }
    }
}
